import fetch from '@/utils/fetch'

export const List = '/govsubsidy/activity/list'

// 新建国补活动
export function createActivityCodes (data) {
  return fetch({
    url: '/govsubsidy/activity/create',
    method: 'post',
    data
  })
}
//修改国补活动
export function updateActivityCodes (data) {
  return fetch({
    url: '/govsubsidy/activity/update',
    method: 'post',
    data
  })
}

// 删除国补活动
export function deleteActivityCodes (data) {
  return fetch({
    url: `/govsubsidy/activity/delete`,
    method: 'post',
    data
  })
}

// 国补活动添加商品
export function setActivityItems (data) {
  return fetch({
    url: '/govsubsidy/activity/add_items',
    method: 'post',
    data
  })
}

// 删除活动关联的商品
export function deleteActivityItems (data) {
  return fetch({
    url: `/govsubsidy/activity/del_items`,
    method: 'post',
    data
  })
}

// 国补活动添加经销商
export function setDealerItems(data) {
    return fetch({
    url: '/govsubsidy/activity/add_dealer',
    method: 'post',
    data
  })
}

// 删除活动关联的经销商列表
export function deleteDealerItems (data) {
  return fetch({
    url: `/govsubsidy/activity/del_dealer`,
    method: 'post',
    data
  })
}